import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import {
  ENDPOINT_DOWNLOAD_CLASS_REPORT,
  ENDPOINT_DOWNLOAD_RESULT_REPORT,
  ENDPOINT_GENERATE_REPORT,
  ENDPOINT_VALIDATE_REPORT,
} from './constants';

export function useReportService() {
  const { backendGetBlob, backendGet } = Sebrae.useBackend();

  const downloadResultReport = React.useCallback(
    (interviewId) =>
      backendGetBlob(`${ENDPOINT_DOWNLOAD_RESULT_REPORT}/${interviewId}/pdf`),
    [backendGetBlob],
  );

  const getLinkReportClassComplete = React.useCallback(
    (idClassRoom) =>
      backendGet(`${ENDPOINT_DOWNLOAD_CLASS_REPORT}/${idClassRoom}`),
    [backendGet],
  );

  const getReportInterviewData = React.useCallback(
    ({ cpf = '', step = '' }) =>
      backendGet(`${ENDPOINT_GENERATE_REPORT}/${cpf}/data?step=${step}`),
    [backendGet],
  );

  const downloadClassReportPdf = React.useCallback(
    (interviews) =>
      backendGetBlob(`${ENDPOINT_DOWNLOAD_CLASS_REPORT}/pdf`, {
        interviews: [interviews],
      }),
    [backendGetBlob],
  );

  const validetaReportOnline = React.useCallback(
    (idInterview) =>
      backendGet(`${ENDPOINT_VALIDATE_REPORT}/${idInterview}`),
    [backendGet],
  );

  return {
    downloadResultReport,
    downloadClassReportPdf,
    getLinkReportClassComplete,
    getReportInterviewData,
    validetaReportOnline
  };
}
